import React from "react";
import SuccessListItem from "./SuccessListItem";

const SuccessList = () => {
  const success_list_items = [
    {
      src: "/img/icon/success_icon01.png",
      title: "Klanttevredenheid",
      percentage: 99,
    },
    {
      src: "/img/icon/success_icon02.png",
      title: "Projecten op Tijd Afgerond",
      percentage: 95,
    },
    {
      src: "/img/icon/success_icon03.png",
      title: "Duurzame Materialen",
      percentage: 90,
    },
    {
      src: "/img/icon/success_icon04.png",
      title: "Maatwerkoplossingen",
      percentage: 97,
    },
  ];

  return (
    <div className="success-list">
      <ul className="list-wrap">
        {success_list_items.map((x, index) => (
          <li key={index}>
            <SuccessListItem item={x} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SuccessList;
